import type { LeadsSearchRowKeys } from "app/pages/sales-intelligence/modules/leads-search";
import type { IInternationalVisitsFilterDto } from "app/pages/sales-intelligence/modules/leads-search-filters";
import { is } from "app/pages/sales-intelligence/utils/type-guards";

export const processInternationalFilters = (
    filterDto: IInternationalVisitsFilterDto,
): readonly LeadsSearchRowKeys[] => {
    const internationalVisits = filterDto.internationalVisits;
    const internationalVisitsShare = filterDto.internationalVisitsShare;

    if (!is.undefined(internationalVisits) || !is.undefined(internationalVisitsShare)) {
        return ["international_visits", "international_visits_share"];
    }

    return [];
};
